import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_EMAILS_LIST: string = '[ecommerce Emails List] Load Ecommerce Emails List';
export const LOAD_ECOMMERCE_EMAILS_LIST_SUCCESS: string = '[ecommerce Emails List] Load Ecommerce Emails List Success';
export const LOAD_ECOMMERCE_EMAILS_LIST_FAIL: string = '[ecommerce Emails List] Load Ecommerce Emails List Fail';

export class LoadEcommerceEmailsList implements Action {
  readonly type: string = LOAD_ECOMMERCE_EMAILS_LIST;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceEmailsListSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_EMAILS_LIST_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceEmailsListFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_EMAILS_LIST_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceEmailsListAction = LoadEcommerceEmailsList | LoadEcommerceEmailsListSuccess | LoadEcommerceEmailsListFail;
